/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Media_RequiredInputs */

const cs_draft_media_required = /** @type {(inputs: Draft_Media_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Povinné`)
};

const en_draft_media_required = /** @type {(inputs: Draft_Media_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required`)
};

/**
* | output |
* | --- |
* | "Required" |
*
* @param {Draft_Media_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_media_required = /** @type {((inputs?: Draft_Media_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Media_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_media_required(inputs)
	return cs_draft_media_required(inputs)
});